export const TypeOfWorkCategory  = {
    NON_BILLABLE: 'NON_BILLABLE',
    BILLABLE: 'BILLABLE'
}



// WEBPACK FOOTER //
// ./web/js/typesOfWork/constants.js